export default {
  title: 'Trasferisci sito web',
  buttons: {
    cancel: 'Annulla',
    transfer: 'Trasferisci',
  },
  fields: {
    target_franchise: {
      label: 'Franchise di destinazione',
      description: 'Seleziona il franchise a cui trasferire il sito web',
    },
    sync_companies: {
      label: 'Mappature aziende',
      description: 'Associa le aziende del franchise di destinazione alle aziende della vetrina',
      franchise_company: 'Azienda franchise',
      storefront_company: 'Azienda vetrina',
      select_franchise_company: 'Seleziona azienda franchise',
      select_storefront_company: 'Seleziona azienda vetrina',
      franchise_company_required: "L'azienda franchise è obbligatoria",
      storefront_company_required: "L'azienda vetrina è obbligatoria",
    },
  },
  toasts: {
    failed_to_load_companies: 'Caricamento aziende fallito',
    no_companies_selected: 'Aggiungi almeno una mappatura aziendale',
    failed_to_transfer: 'Trasferimento sito web fallito',
    transfer_success: 'Sito web trasferito con successo',
    franchise_already_connected: 'Il franchise di destinazione è già collegato a un sito web',
  },
};
